import Modal1 from "../../DIsplay/Modal/Modal1";
import Button1 from "../../form/Button1";
import { enqueueSnackbar } from "notistack";
import { Modal3 } from "../../DIsplay/Modal/Modal3";
import { AddBankForm } from "../../../pages/Settings/Finance/AddBankForm";
import { useEffect, useState } from "react";
import getBankAccounts from "../../../controllers/settings/finance/getBankAccounts";
import requestWalletPayout from "../../../controllers/settings/wallet/requestWalletPayout";
import getWallet from "../../../controllers/settings/wallet/getWallet";
import { InputAdornment } from "@mui/material";
import TextInput from "../../form/TextInput";
import { formatMoney } from "../../../features/utils/formatMoney";
import RadioGroup from "../../form/RadioGroup";

function TransactionRequestWithdrawalModal({ setOpen, open, callback }) {
  const [loading, setLoading] = useState(false);
  const [bankLoading, setBankLoading] = useState(false);
  const [balanceData, setBalanceData] = useState({ balance: 0 });
  const [bankAccountId, setBankAccountId] = useState();
  const [banks, setBanks] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [amount, setAmount] = useState(0);

  async function loadWallet() {
    const res = await getWallet();
    if (res.return) {
      setBalanceData(res?.data);
    }
  }

  const load = async () => {
    const promises = [loadBanks(), loadWallet()];
    await Promise.all(promises);
  };

  useEffect(() => {
    load();
  }, []);

  async function loadBanks() {
    setBankLoading(true);

    const savedAccount = await getBankAccounts();
    // console.log({ savedAccount });
    if (savedAccount.return) {
      const data = savedAccount.data?.data || [];
      setBanks(data);
    }
    setBankLoading(false);
  }

  // console.log({ banks });

  async function handleSubmit() {
    setLoading?.(true);
    const res = await requestWalletPayout({
      bankAccountId,
      amount: Number(amount),
    });
    setLoading?.(false);
    if (res?.return) {
      enqueueSnackbar(res?.msg, { variant: "success" });
      callback && callback(res);
      //   reload && reload();
      setTimeout(() => {
        window.location.reload();
      }, 100);
      setOpen(false);
    } else enqueueSnackbar(res?.msg, { variant: "error" });
  }

  return (
    <>
      <Modal3 {...{ open, setOpen }} title={"Wallet Withdrawal"}>
        <div className="flex flex-col gap-4 p-6">
          <div className="flex justify-between gap-4 items-center">
            <p>Wallet Balance</p>
            <h5 className="">
              {formatMoney((balanceData?.balance || 0)?.toFixed(2))}
            </h5>
          </div>
          <TextInput
            label="Enter withdrawal amount"
            type="number"
            value={amount}
            onChange={(ev) => setAmount(ev.target.value)}
            InputProps={{
              endAdornment: <InputAdornment position="end">NGN</InputAdornment>,
            }}
          />
          <div className="flex flex-col gap-2">
            <div className="flex justify-between gap-4 items-center">
              <p>Select Bank Account</p>
              <div className="inline-block">
                <Button1 variant="text" onClick={() => setShowAdd(true)}>
                  + Add Account
                </Button1>
              </div>
            </div>
            <RadioGroup
              options={banks?.map((obj) => ({
                ...obj,
                value: obj?._id,
                label: obj?.bankName,
                render: (obj) => (
                  <div className="flex flex-col gap-1">
                    <div>{obj?.accountName}</div>
                    <div className="flex justify-between gap-4 w-full">
                      <span>{obj?.accountNumber}</span>
                      <span>{obj?.bankName}</span>
                    </div>
                  </div>
                ),
              }))}
              value={bankAccountId}
              onChange={(val) => setBankAccountId(val)}
            />
          </div>
          {/* <TextInput select value={bankAccountId} label='Bank'
                onChange={(ev) => setBankAccountId(ev.target.value)}
              >
                {banks?.map((bank,i) => (
                  <MenuItem key={i} value={bank?.account} className='flex flex-col gap-1 !items-start justify-start text-start'>
                    <small>{bank?.bankName}</small>
                    {bank?.accountName}
                    <span>{bank?.accountNumber}</span>
                  </MenuItem>
                ))}
              </TextInput> */}
          <div className="flex gap-4 items-center">
            <div>
              <Button1 variant="outlined" onClick={() => setOpen(false)}>
                Close
              </Button1>
            </div>
            <Button1
              disabled={!bankAccountId}
              loading={loading}
              onClick={() => handleSubmit()}
            >
              Confirm
            </Button1>
          </div>
        </div>
      </Modal3>
      <Modal1 open={showAdd} setOpen={setShowAdd}>
        <div className="p-6">
          <AddBankForm
            banks={banks}
            reload={() => {
              setShowAdd(false);
            }}
          />
        </div>
      </Modal1>
    </>
  );
}

export default TransactionRequestWithdrawalModal;
